(function($) {

    /*
     *  new_map
     *
     *  This function will render a Google Map onto the selected jQuery element
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	4.3.0
     *
     *  @param	$el (jQuery element)
     *  @return	n/a
     */

    function new_map( $el ) {

        // var
        var $markers = $el.find('.marker');


        // vars
        var args = {
            zoom		: 16,
            center		: new google.maps.LatLng(0, 0),
            mapTypeId	: google.maps.MapTypeId.ROADMAP
        };


        // create map
        var map = new google.maps.Map( $el[0], args);


        // add a markers reference
        map.markers = [];


        // add markers
        $markers.each(function(){

            add_marker( $(this), map );

        });


        // center map
        center_map( map );


        // return
        return map;

    }

    /*
     *  add_marker
     *
     *  This function will add a marker to the selected Google Map
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	4.3.0
     *
     *  @param	$marker (jQuery element)
     *  @param	map (Google Map object)
     *  @return	n/a
     */

    function add_marker( $marker, map ) {

        // var
        var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

        // create marker
        var marker = new google.maps.Marker({
            icon:  $marker.attr('data-icon'),
            position	: latlng,
            map			: map
        });

        // add to array
        map.markers.push( marker );

        // if marker contains HTML, add it to an infoWindow
        if( $marker.html() )
        {
            // create info window
            var infowindow = new google.maps.InfoWindow({
                content		: $marker.html()
            });

            // show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', function() {

                infowindow.open( map, marker );

            });
        }

    }

    /*
     *  center_map
     *
     *  This function will center the map, showing all markers attached to this map
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	4.3.0
     *
     *  @param	map (Google Map object)
     *  @return	n/a
     */

    function center_map( map ) {

        // vars
        var bounds = new google.maps.LatLngBounds();

        // loop through all markers and create bounds
        $.each( map.markers, function( i, marker ){

            var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

            bounds.extend( latlng );

        });

        // only 1 marker?
        if( map.markers.length == 1 )
        {
            // set center of map
            map.setCenter( bounds.getCenter() );
            map.setZoom( 16 );
        }
        else
        {
            // fit to bounds
            map.fitBounds( bounds );
        }

    }

    /*
     *  document ready
     *
     *  This function will render each map when the document is ready (page has loaded)
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	5.0.0
     *
     *  @param	n/a
     *  @return	n/a
     */
// global var


    $(document).ready(function(){
        var map = null;
        $("img.lazy").lazyload();
        $('.acf-map').each(function(){

            // create map
            map = new_map( $(this) );

        });
    });

})(jQuery);

var distrito = "";
var concelho = "";
$(document).ready(function(){
    $('.slider-partners').bxSlider({
        auto: true,
        autoControls: true,
        pause: 5000
    });

    /*
     * Clubs map
     */

    distrito = $("#club-cards").data("distrito");
    concelho = $("#club-cards").data("concelho");
    $.ajax({

        url: ajaxurl,
        type: 'post',
        data: {
            action: 'ajax_get_clubs_handler',
            distrito: distrito,
            concelho: concelho
        },
        success: function( data ) {
            console.log(data);
            var obj = $.parseJSON(data);

            if ( obj.success ){

                if ( obj.result.length > 0 ){
                    $("#map_wrapper").removeClass("hidden");
                    map_initialize( obj.result );
                } else {
                    $("#map_wrapper").addClass("hidden");
                }

            }
        }

    });

});



function map_initialize( result ) {
    //console.log(result);
    var map;
    var bounds = new google.maps.LatLngBounds();
    var mapOptions = {
        mapTypeId: 'roadmap',
        gestureHandling: 'greedy'
    };
    var markers = result;

    // Display a map on the page
    map = new google.maps.Map(document.getElementById("map_canvas"), mapOptions);
    map.setTilt(45);

    // Display multiple markers on a map
    var infoWindow = new google.maps.InfoWindow(), marker, i;

    // Loop through our array of markers & place each one on the map
    for( i = 0; i < markers.length; i++ ) {

        var position = new google.maps.LatLng(markers[i].lat,markers[i].lng);
        bounds.extend(position);
        marker = new google.maps.Marker({
            position: position,
            icon: window.location.origin + "/wp-content/themes/federacaojudo/img/mapPin.png",
            map: map,
            title: 'title'
        });

        // Allow each marker to have an info window
        google.maps.event.addListener(marker, 'click', (function(marker, i) {
            return function() {
                infoWindow.setContent( markers[i].info );
                infoWindow.open(map, marker);
            }
        })(marker, i));

        // Automatically center the map fitting all markers on the screen
        map.fitBounds(bounds);
    }

    var zoom = 6;

    if( typeof distrito != "undefined" ){
        zoom = 8;
    }
    console.log(zoom);
    // Override our map zoom level once our fitBounds function runs (Make sure it only runs once)
    var boundsListener = google.maps.event.addListener((map), 'bounds_changed', function(event) {
        this.setZoom( zoom );
        google.maps.event.removeListener(boundsListener);
    });

}

